/* eslint-disable no-underscore-dangle */
import type { ObjectDirective, } from 'vue';

interface DebouncedClickOptions {
  /** 点击间隔最小值（单位：ms） */
  wait: number;
  /** 是否绑定事件在捕获阶段 */
  capture: boolean;
  /** 是否阻止事件冒泡 */
  stop: boolean;
  /** 是否阻止默认事件 */
  prevent: boolean;
}

interface DebouncedClickElement extends HTMLElement {
  __debounced_click_timer?: number;
  __debounced_click_stop(): void;
}

type BindingValueFunction = (event: Event) => void;

type BindingValueArray = [BindingValueFunction, Partial<DebouncedClickOptions> | undefined]

const DEFAULT_OPTIONS: DebouncedClickOptions = {
  wait: 800,
  capture: true,
  stop: false,
  prevent: false,
};

export const vDebouncedClickName = 'debouncedClick';

export const vDebouncedClick: ObjectDirective<
  DebouncedClickElement,
  BindingValueFunction | BindingValueArray
> = {
  mounted(el: DebouncedClickElement, binding) {
    const { modifiers, } = binding;
    const [callback, options = {},] = Array.isArray(binding.value)
      ? binding.value
      : [binding.value,];
    const totalOptions = { ...DEFAULT_OPTIONS, ...options, };

    const resetTimer = () => {
      window.clearTimeout(el.__debounced_click_timer);
      el.__debounced_click_timer = window.setTimeout(() => {
        delete el.__debounced_click_timer;
      }, totalOptions.wait);
    };

    const handleClick = (event: Event) => {
      // HACK: 按钮已被禁用的情况下不触发事件
      if (el.className.includes('disabled')) {
        return;
      }
      if (totalOptions.stop || modifiers.stop) {
        event.stopPropagation();
      }
      if (totalOptions.prevent || modifiers.prevent) {
        event.preventDefault();
      }
      if (!el.__debounced_click_timer) {
        // eslint-disable-next-line callback-return
        callback(event);
      } else {
        console.log('click ignored!');
      }
      resetTimer();
    };

    el.addEventListener('click', handleClick, totalOptions.capture);

    el.__debounced_click_stop = () => {
      el.removeEventListener('click', handleClick, totalOptions.capture);

      if (el.__debounced_click_timer) {
        window.clearTimeout(el.__debounced_click_timer);
        delete el.__debounced_click_timer;
      }
    };
  },

  unmounted(el: DebouncedClickElement) {
    el.__debounced_click_stop();
  },
};
